import angular from "angular";

angular
    .module('articlesControl.article', [])
    .service('Article', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/articles';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.destroy = function (id) {
            return $http.post(uri(id), {_method: 'DELETE'});
        };

        this.publish = function (id) {
            return $http.post(uri(id, 'publish'));
        };

    }]);

export default 'articlesControl.article'



// WEBPACK FOOTER //
// ./resources/assets/modules/articles-control/article.js